import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import useFetchUserById from '../../../hooks/users/useFetchUserById';
import './userForm.css';
import Loading from '../Loading/Loading';

const UserForm = ({ isEditing, onFormSubmit, setFlashMessage, onGoBack }) => {
  if (typeof setFlashMessage !== 'function') {
    console.error('setFlashMessage prop is not a function');
    // Provide a fallback
    setFlashMessage = () => {};
  }

  const { id } = useParams();
  const { user, loading, error } = useFetchUserById(isEditing ? id : null);

  const initialFormData = {
    name: '',
    telephone: '',
    email: '',
  };

  const [state, setState] = useState(initialFormData);

  useEffect(() => {
    if (isEditing && user) {
      setState({
        name: user.name || '',
        telephone: user.phoneNumber || '',
        email: user.email || '',
      });
    }
  }, [isEditing, user]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = {
      email: state.email,
      name: state.name,
      phoneNumber: state.telephone // Rename telephone to phoneNumber to match backend
    };

    // Add user ID for updates
    if (isEditing && user) {
      formData.id = user.id;
    }

    try {
      const url = isEditing 
        ? `${process.env.REACT_APP_BACKEND_STAGING_URL}/api/admin/user/update` 
        : `${process.env.REACT_APP_BACKEND_STAGING_URL}/api/admin/create-user`;
      const method = isEditing ? 'PATCH' : 'POST';
      
      const response = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
        credentials: 'include',
      });

      if (response.status === 400) {
        const errorData = await response.json();
        setFlashMessage(errorData.message || 'El correo electrónico ya está en uso.');
        return;
      }

      if (!response.ok) throw new Error('Failed to submit form.');
      
      onFormSubmit();
    } catch (error) {
      console.error('Error submitting form:', error);
      setFlashMessage('Error al actualizar el usuario.');
    }
  };

  const handleInputChange = (field, value) => {
    setState((prevState) => ({ ...prevState, [field]: value }));
  };

  if (loading) return <div><Loading/></div>;
  if (error) return <div>Error: {error.message}</div>;

  return (
    <form onSubmit={handleSubmit} className="user-form__container">
      <h2>{isEditing ? 'Edita este usuario' : ''}</h2>
      <div className="user-form__inputs-container">
        <div className="user-form__group">
          <label htmlFor="name">Nombre:</label>
          <input
            type="text"
            id="name"
            value={state.name}
            onChange={(e) => handleInputChange('name', e.target.value)}
          />
        </div>

        <div className="user-form__group">
          <label htmlFor="telephone">Teléfono:</label>
          <input
            type="text"
            id="telephone"
            value={state.telephone}
            onChange={(e) => handleInputChange('telephone', e.target.value)}
          />
        </div>

        <div className="user-form__group">
          <label htmlFor="email">E-mail:</label>
          <input
            type="text"
            id="email"
            value={state.email}
            onChange={(e) => handleInputChange('email', e.target.value)}
          />
        </div>
      </div>

      <div className="user-form__button-container"> 
        <button type="submit" className="user-form__button">
          {isEditing ? 'Editar' : 'Crear'}
        </button>
      </div>
    </form>
  );
};

export default UserForm;
